import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import AddBlog from './components/AddBlog/AddBlog';
import Articles from './pages/Articles/Articles';
import Article from './pages/Article/Article';
import './App.css';
import ProtectedRoute from './ProtectedRoute';
import AdminLoginCard from './pages/Admin/AdminLoginCard';
import Footer from './components/Footer';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/articles' element={<Articles />} />
        <Route path='/article/:id' element={<Article />} />
        <Route path='/admin/login' element={<AdminLoginCard />} />
        <Route element={<ProtectedRoute element={<AddBlog />} />} path='/addblog' />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
